import { RxStateComponent } from '@alliance/shared/models'
import { Component, ChangeDetectionStrategy } from '@angular/core'
import { Translations } from '../localization/translations'
import { IconDetailsQuestionMark } from '@alliance/shared/icons'
import { TooltipPosition } from '@alliance/santa/tooltip'
import { VisibilityStateService } from '../../api'
import { listAnimation } from './animation'
import { AtsGtmEvent, OnboardingCtaClickedEvent } from '@alliance/ats/analytics/utils'

@Component({
  selector: 'alliance-ats-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.tw.css'],
  animations: [listAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnboardingComponent extends RxStateComponent<{ isOpen: boolean; isVisible: boolean }> {
  public readonly ICONS = { IconDetailsQuestionMark }
  public readonly analyticsEvent: AtsGtmEvent<string | null> = { event: OnboardingCtaClickedEvent }
  public TooltipPosition = TooltipPosition
  public readonly state = this.connectViewState(['isVisible', 'isOpen'])
  public constructor(private visibilityStateService: VisibilityStateService, public translations: Translations) {
    super()

    this.initState({
      isVisible: this.visibilityStateService.select('isOnboardingAvailable'),
      isOpen: this.visibilityStateService.select('isOpen')
    })
  }
}
